{
  "povzetek": {
    "title": "Summary",
    "skupno30": "Last 30 days",
    "skupno90": "Last 90 days",
    "skupno365": "Last 365 days",
    "vsiO": "All completed flights",
    "povprecje": "Average flight duration",
    "najveckratV": "The most frequently flown aircraft"
  },
  "table": {
    "datum": "Date",
    "letalisce": "Airport",
    "ttof": "TTOF",
    "vzlet": "Takeoff",
    "diaryTitle": "Diary Entries"
  },
  "modal": {
    "datum": "Date:",
    "casL": "Total flight time:",
    "pristankiD": "Number of landings (day):",
    "pristankiN": "Number of landings (night):",
    "op": "Operating conditions:",
    "vp": "Pilot role:",
    "fstd": "FSTD time:",
    "odhod": "Departure:",
    "krajO": "Departure location:",
    "prihod": "Arrival:",
    "krajP": "Arrival location:",
    "zrakoplov": "Aircraft:",
    "reg": "Registration:",
    "vodjaZ": "Pilot-in-command name:",
    "opomba": "Note:"
  },
  "labels": {
    "casO": "Departure time:",
    "casP": "Arrival time:",
    "model": "Aircraft model:",
    "reg": "Aircraft registration:",
    "vodjaZ": "Pilot-in-command name:",
    "posadka": "Single crew / Multi crew:",
    "pogoji": "Flight conditions:",
    "pD": "Day",
    "pN": "Night",
    "stPristankov": "Number of landings:",
    "ttof": "Ttof:",
    "op": "Operating conditions:",
    "opD": "Day",
    "opN": "Night",
    "vp": "Pilot role:",
    "fstd": "FSTD time:",
    "opomba": "Note:",
    "pristanek": "Select landing:",
    "regL": "Select glider registration:"
  },
  "buttons": {
    "urediPodatke": "Edit data",
    "posodobiPodatke": "Update data",
    "brisiZapis": "Delete record",
    "brisiIzbiro": "Clear selection",
    "natisni": "Print",
    "poslji": "Send"
  }
}